import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './TiktokSidebar.css';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import MessageIcon from '@mui/icons-material/Message';
import ShareIcon from '@mui/icons-material/Share';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from "./Router";
import { SocialPageAvatar } from "./SocialPageAvatar";
import { SocialUserAvatar } from "./SocialUserAvatar";
import { NewSocialPostForm } from "./NewSocialPostForm";
import { TiktokComments } from "./TiktokComments";

const TiktokSidebar = ({
  user,
  video,
  postId,
  hasLiked,
  setHasLiked,
  likes,
  shares,
  messages,
  isAdmin,
  avatar,
  avatarLink,
  commentWindowOpen,
  toggleComments,
}) => {
  const navigate = useNavigate();
  const [nbrLikes, setNbrLikes] = useState(likes || 0);
  const [modalOpen, setModalOpen] = useState(false);
  const [nbrShared, setNbrShared] = useState(shares || 0);
  const [isLikeAnimating, setIsLikeAnimating] = useState(false);

  const comment_it = () => {
    // Utiliser la fonction toggleComments reçue des props
    toggleComments();
  };

  const share_it = () => {   
    setModalOpen(true);
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const like_it = async () => {
    if (!user) {
      alert("Vous devez être connecté pour aimer une vidéo");
      return;
    }

    setIsLikeAnimating(true);
    setTimeout(() => setIsLikeAnimating(false), 1000);

    try {
      if (!hasLiked) {
        const nl = {
          post_id: postId,
          user_id: user.user_id
        };
        await sdk.models.PostsLike.create(nl);
        setNbrLikes(prev => prev + 1);
      } else {
        await sdk.models.PostsLike.deleteMyLike({post_id: postId});
        setNbrLikes(prev => Math.max(0, prev - 1));
      }
      setHasLiked(!hasLiked);
    } catch (error) {
      console.error("Error toggling like:", error);
    }
  };

  const delete_it = () => {
    if (confirm("Êtes-vous sûr de vouloir supprimer cette vidéo?")) {
      // Future implementation for deleting
      console.log('Would delete post', postId);
    }
  };

  const goToProfile = () => {
    if (video.page_id) {
      navigate(`/page/${video.page_id}`);
    } else if (video.user_id) {
      navigate(`/user/${video.user_id}`);
    } else if (avatarLink) {
      navigate(avatarLink.substring(1));
    }
  };

  return (
    <>
      <div className="videoSidebar">
        <div className="videoSidebar__button avatar-button" onClick={goToProfile}>
          <div className="avatar-container">
            {video.page_id ? (
              <SocialPageAvatar page_id={video.page_id} />
            ) : (
              <SocialUserAvatar user_id={video.user_id || user?.user_id} />
            )}
            <div className="username-tooltip">{video.postBy || "Utilisateur"}</div>
          </div>
        </div>
        
        <div className={`videoSidebar__button ${isLikeAnimating ? 'animate-like' : ''}`}>
          {hasLiked ? (
            <FavoriteIcon 
              className="like-icon liked" 
              fontSize="large" 
              onClick={like_it} 
            />
          ) : (
            <FavoriteBorderIcon 
              className="like-icon" 
              fontSize="large" 
              onClick={like_it} 
            />
          )}
          <p>{nbrLikes}</p>
        </div>
        
        <div className="videoSidebar__button">
          <MessageIcon fontSize="large" onClick={comment_it} />
          <p>{messages}</p>
        </div>
        
        <div className="videoSidebar__button">
          <ShareIcon fontSize="large" onClick={share_it} />
          <p>{nbrShared}</p>
        </div>
        
        {isAdmin && (
          <div className="videoSidebar__button delete-button">
            <DeleteIcon fontSize="large" onClick={delete_it} />
          </div>
        )}
      </div>
      
      {/* Modal de partage du post */}
      <NewSocialPostForm
        user={user}
        sharedFromId={postId}
        onClose={toggleModal}
        isOpen={modalOpen}
        toggleModal={toggleModal}
        onSubmitSuccess={() => {
          toggleModal();
          setNbrShared(prev => prev + 1);
          console.log("Post partagé avec succès");
        }}
      />
      
      {/* Nouveau composant pour les commentaires */}
      <TiktokComments
        post={video}
        isOpen={commentWindowOpen}
        onClose={toggleComments}
        user={user}
      />
    </>
  );
};

export { TiktokSidebar };